import { GanttChartSquare } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";

export const BrandMark = ({ size = "h-9 w-9", text = "text-lg" }) => {
  const { branding } = useBranding();
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-mark">
      <div className={`${size} rounded-lg bg-primary flex items-center justify-center overflow-hidden`}>
        {branding.logo_url ? <img src={branding.logo_url} alt="logo" className="h-full w-full object-contain" /> : <GanttChartSquare className="h-5 w-5 text-white" />}
      </div>
      <span className={`font-heading font-bold ${text}`}>{branding.platform_name}</span>
    </div>
  );
};
